import React, { useEffect } from "react";
import { getProfileImage } from "../../redux/actions/imgAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const TeamMemberCard = ({ member }) => {
  // console.log("TeamMemberCard render", member);
  // console.log("TeamMemberCard member.id", member?.id);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { imageData } = useSelector((state) => state.img);

  useEffect(() => {
    if (member?.id) {
      // console.log(
      //   "🔄 TeamMemberCard - useEffect tetiklendi - member.id:",
      //   member.id
      // );
      dispatch(getProfileImage(member.id));
    }
  }, [dispatch, member.id]);

  // Görseli kontrol et ve base64 formatına dönüştür
  const memberImage = imageData[member.id]?.data?.[0]?.content
    ? `data:image/jpeg;base64,${imageData[member.id].data[0].content}`
    : "/defaultPerson.svg";

  // console.log("📊 TeamMemberCard - imageData:", imageData);
  // console.log("🖼️ TeamMemberCard - memberImage:", memberImage);

  const handleClick = () => {
    const path =
      member.type === "JUNIOR"
        ? `/junior/${member.userName}`
        : `/senior/${member.userName}`;
    navigate(path, { state: { userId: member.id } });
  };

  return (
    <div
      className="max-w-[400px] min-w-[219px] h-[64px] rounded-tl-lg bg-white flex items-center justify-between shrink-0 cursor-pointer"
      onClick={handleClick}
    >
      {/* Üye Bilgileri */}
      <div className="flex h-[64px] items-center gap-[10px]">
        <img
          src={memberImage}
          alt={member.name || "Team Member"}
          className="w-12 h-12 rounded-full object-cover"
          onError={(e) => {
            // console.error("❌ Görsel yüklenemedi:", e);
            e.target.src = "/defaultPerson.svg";
          }}
        />
        <div>
          <h3 className="text-sm font-semibold text-dark text-poppins">
            {member.name || "İsim belirtilmemiş"}
          </h3>
          <p className="text-sm text-grayy text-poppins">
            {member.position?.name || "Rol belirtilmemiş"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeamMemberCard;
